export class Option {

    id?: string | number;
    name?: string;
    keyCode?: string;

    constructor(source: Partial<Option>) {
        Object.assign(this, source);
    }
}